import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/inventory", label: "Inventory" },
  { to: "/financing", label: "Financing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-white/10 bg-[#0a0a0b]/80 backdrop-blur-xl"
    >
      <div className="hidden border-b border-white/10 bg-[#FFB800]/10 md:block">
        <div className="mx-auto flex max-w-[1400px] items-center justify-center gap-2 px-6 py-2 font-mono text-[10px] uppercase tracking-[0.3em] text-[#FFB800] lg:px-10">
          <span>◆</span>
          Texas-based dealer — shipping nationwide to all 50 states
          <span>◆</span>
        </div>
      </div>
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-10">
        <Link
          to="/"
          data-testid="brand-logo"
          className="flex items-center gap-3"
        >
          <div className="flex h-10 w-10 items-center justify-center bg-[#FFB800] font-display text-2xl font-black text-black">
            TI
          </div>
          <div className="hidden flex-col leading-none sm:flex">
            <span className="font-display text-2xl font-black uppercase tracking-wide text-white">
              Texas Iron
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FFB800]">
              Heavy Equipment / TX
            </span>
          </div>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 font-display text-sm font-semibold uppercase tracking-widest transition-colors ${
                  isActive
                    ? "text-[#FFB800]"
                    : "text-white/70 hover:text-[#FFB800]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-4 lg:flex">
          <a
            href="tel:+18005550123"
            data-testid="header-phone"
            className="flex items-center gap-2 font-mono text-sm text-white/80 hover:text-[#FFB800]"
          >
            <Phone className="h-4 w-4" />
            (800) 555-0123
          </a>
          <button
            data-testid="header-cta-quote"
            onClick={() => navigate("/inventory")}
            className="bg-[#FFB800] px-6 py-3 font-display text-sm font-bold uppercase tracking-widest text-black transition-colors hover:bg-[#E5A600]"
          >
            Browse Inventory
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 lg:hidden" data-testid="mobile-menu">
          <div className="flex flex-col px-6 py-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `border-b border-white/5 py-3 font-display text-base font-semibold uppercase tracking-wider ${
                    isActive ? "text-[#FFB800]" : "text-white"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href="tel:+18005550123"
              className="mt-4 flex items-center gap-2 text-white/80"
            >
              <Phone className="h-4 w-4" /> (800) 555-0123
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
